import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import styles from './Input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, className, id, ...rest },
  ref,
) {
  const inputId = id ?? rest.name;
  return (
    <label className={styles.wrapper} htmlFor={inputId}>
      {label ? <span className={styles.label}>{label}</span> : null}
      <input
        ref={ref}
        id={inputId}
        className={[styles.input, className].filter(Boolean).join(' ')}
        {...rest}
      />
      {error ? <span className={styles.error}>{error}</span> : null}
    </label>
  );
});
